import { isFunction } from 'lodash';

/**
 * Resolves options from a resource getter, calling it with `optionsParams` when the getter is parameterised.
 *
 * @param {Object} rootGetters - Vuex root getters.
 * @param {Object} params
 * @param {String} params.resource - Vuex module name, e.g. 'storeGroups'.
 * @param {String} params.getOptionsFunction - Getter name within the module.
 * @param {Object} [params.optionsParams] - Arguments for parameterised getters.
 * @returns {Array} Resource options.
 */
export default function getResourceOptions(
    rootGetters,
    { resource, getOptionsFunction, optionsParams = {} }
) {
    const options = rootGetters[`${resource}/${getOptionsFunction}`];
    return isFunction(options) ? options(optionsParams) : options;
}
